import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ROLE_HOME = {
  Owner: "/dashboard",
  Manager: "/dashboard",
  Designer: "/leads",
  Accounts: "/invoices",
  "Site Supervisor": "/projects",
  Client: "/projects",
};

export default function RoleLanding() {
  const { user } = useAuth();
  const dest = ROLE_HOME[user?.role] || "/dashboard";
  return <Navigate to={dest} replace />;
}
